
import React, { ReactNode } from "react";
import { LucideIcon } from "lucide-react";

interface ServiceOverviewSectionProps {
  title: string;
  description: React.ReactNode;
  featureIcon?: LucideIcon;
  featureTitle?: string;
  featureDescription?: string;
  imageSrc: string;
  imageAlt: string;
}

export const ServiceOverviewSection: React.FC<ServiceOverviewSectionProps> = ({
  title,
  description,
  featureIcon: FeatureIcon,
  featureTitle,
  featureDescription,
  imageSrc,
  imageAlt,
}) => {
  return (
    <section className="py-16 bg-dental-offwhite">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="flex-1">
            <h2 className="text-3xl font-bold mb-6 text-dental-text">{title}</h2>
            {typeof description === "string" ? (
              <p className="mb-4">{description}</p>
            ) : (
              description
            )}
            
            {FeatureIcon && featureTitle && featureDescription && (
              <div className="flex items-center p-4 bg-white rounded-lg shadow-sm border border-gray-100">
                <FeatureIcon className="w-8 h-8 text-dental-highlight mr-4" />
                <div>
                  <h3 className="font-semibold">{featureTitle}</h3>
                  <p className="text-sm text-gray-600">{featureDescription}</p>
                </div>
              </div>
            )}
          </div>
          <div className="flex-1">
            <img
              src={imageSrc}
              alt={imageAlt}
              className="rounded-lg shadow-lg w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
